import { OrbitMark } from "@/components/OrbitMark";

const AudioBars = ({ on }) => (
  <span className={`audio-bars flex h-3 items-center gap-[2.5px] ${on ? "" : "off"}`} aria-hidden="true">
    <span /><span /><span /><span />
  </span>
);

// Simple top logo placement over the opening; the persistent navigation lives at the bottom.
export const Nav = ({ audioOn, onToggleAudio }) => (
  <header data-testid="hero-nav" className="absolute inset-x-0 top-0 z-30 flex items-center justify-between px-5 py-5 sm:px-8 lg:py-7">
    <a href="#top" data-testid="nav-pmp-logo" aria-label="Precision Machined Products — home" className="flex items-center rounded-lg bg-[#fafaf7] px-3.5 py-2 shadow-lg shadow-black/20 transition-transform duration-300 hover:-translate-y-0.5">
      <img src="/pmp-logo.jpg" alt="Precision Machined Products" className="h-6 w-auto sm:h-7" />
    </a>
    <button
      type="button"
      onClick={onToggleAudio}
      data-testid="audio-toggle"
      aria-pressed={audioOn}
      className="flex items-center gap-2.5 rounded-full border border-white/10 bg-[#070A0F]/60 px-4 py-2 backdrop-blur-xl transition-colors duration-300 hover:bg-white/10"
    >
      <AudioBars on={audioOn} />
      <span className="font-mono text-[10px] font-medium tracking-[0.3em] text-white/90">AUDIO</span>
    </button>
  </header>
);
